/**
 * Icon resolver — maps icon name strings to lucide-react components.
 *
 * The ICON_MAP is CODEGEN (`scripts/generate/generators/icon-map.ts`) — derived from every
 * icon name referenced across the tree (`iconName:`/`icon:` in manifests + literal
 * `getIconWithFallback('…')` calls), validated against lucide's real exports. Adding an
 * icon to a manifest auto-includes it; an unknown name degrades to HelpCircle. This module
 * keeps only the thin accessors (Rule 18/35 — no hand-maintained map).
 */

import { HelpCircle, type LucideIcon } from 'lucide-react';
import { ICON_MAP } from './generated/icon-map.generated.js';

export function getIconWithFallback(
  name: string | null | undefined,
  _fallback?: string,
): LucideIcon {
  if (!name) return HelpCircle;
  return ICON_MAP[name] ?? HelpCircle;
}

export function getIconSync(name: string): LucideIcon | undefined {
  return ICON_MAP[name];
}
